import { render, staticRenderFns } from "./ViewRouter.vue?vue&type=template&id=59d84c38&scoped=true&"
import script from "./ViewRouter.ts?vue&type=script&lang=ts&"
export * from "./ViewRouter.ts?vue&type=script&lang=ts&"
import style0 from "./ViewRouter.vue?vue&type=style&index=0&id=59d84c38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d84c38",
  null
  
)

export default component.exports